import { render } from "./MenuProfile.vue?vue&type=template&id=3c15cbad&scoped=true&ts=true"
import script from "./MenuProfile.vue?vue&type=script&lang=ts"
export * from "./MenuProfile.vue?vue&type=script&lang=ts"

import "./MenuProfile.vue?vue&type=style&index=0&id=3c15cbad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c15cbad"]])

export default __exports__